/**
 * Generic type guard. Usage:
 * isType<IAppKey>(appKey, 'clientId'): boolean
 *
 * @param obj Object to validate type of
 * @param prop Property used to validate object type with
 * @returns boolean
 */
export const isType = <T>(obj: any, prop: keyof T): obj is T => (obj as T)[prop] !== undefined;
